"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPreloadedState = void 0;
const env_1 = require("astra-core/utils/env");
const getPreloadedState = (key, initialState) => {
    if (!env_1.isBrowser) {
        return initialState;
    }
    try {
        if (window.__PRELOADED_STATE__) {
            return window.__PRELOADED_STATE__[key] || initialState;
        }
        return initialState;
    }
    catch (e) {
        console.error(`Couldnt get __PRELOADED_STATE__ for key ${key}`);
        return initialState;
    }
};
exports.getPreloadedState = getPreloadedState;
//# sourceMappingURL=state.js.map